const routes = [
  {
    path: '/profile/me',
    name: 'profile-me',
    component: () => import('@/views/Profile/Me.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/company',
    name: 'profile-company',
    component: () => import('@/views/Profile/Company.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/certs',
    name: 'profile-certs',
    component: () => import('@/views/Profile/Certs.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/website',
    name: 'profile-website',
    component: () => import('@/views/Profile/Websites.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/api',
    name: 'profile-api',
    component: () => import('@/views/Profile/API.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/menu/roles/:roleId/detail/:tabName?',
    name: 'profile-role-detail',
    component: () => import('@/views/Profile/RoleDetail.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/menu',
    name: 'profile-menu',
    component: () => import('@/views/Profile/MenuUser.vue'),
    meta: {
      auth: true
    },
    redirect: '/profile/menu/users',
    children: [
      {
        path: '/profile/menu/users',
        name: 'profile-users',
        component: () => import('@/views/Profile/Users.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/profile/menu/branches',
        name: 'profile-branches',
        component: () => import('@/views/Profile/Branches.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/profile/menu/consultants',
        name: 'profile-consultants',
        component: () => import('@/views/Profile/Consultants.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/profile/menu/roles',
        name: 'profile-roles',
        component: () => import('@/views/Profile/Roles.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: '/profile/menu/configuration',
        name: 'profile-configuration',
        component: () => import('@/views/Profile/Configuration.vue'),
        meta: {
          auth: true
        }
      }
    ]
  },
  {
    path: '/profile/mails',
    name: 'profile-mails',
    component: () => import('@/views/Profile/Mail/Custom.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/cms',
    name: 'profile-cms',
    component: () => import('@/views/Profile/CMS/MenuPages.vue'),
    meta: {
      auth: true
    },
    redirect: '/profile/cms/pages',
    children: [
      {
        path: 'pages',
        name: 'profile-pages',
        component: () => import('@/views/Profile/CMS/Pages.vue'),
        meta: {
          auth: true
        }
      },
      {
        path: 'widgets',
        name: 'profile-widgets',
        component: () => import('@/views/Profile/CMS/Widgets.vue'),
        meta: {
          auth: true
        }
      }
    ]
  },
  {
    path: '/profile/documents',
    name: 'profile-documents',
    component: () => import('@/views/Profile/Documents.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/integrations',
    name: 'profile-integrations',
    component: () => import('@/views/Profile/Integrations.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/trainings',
    name: 'profile-tutorials',
    component: () => import('@/views/Profile/Trainings.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/webhooks',
    name: 'profile-webhooks',
    component: () => import('@/views/Profile/Webhooks.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/profile/tickets',
    name: 'profile-tickets',
    component: () => import('@/views/Profile/Tickets.vue'),
    meta: {
      auth: true,
      permission: 'tickets'
    }
  },
  {
    path: '/profile/tickets/:id',
    name: 'profile-ticket-detail',
    component: () => import('@/views/Profile/TicketDetail.vue'),
    meta: {
      auth: true,
      permission: 'tickets'
    }
  }
]
export default routes
